module.exports = __webpack_public_path__ + "static/media/img5.6cef9171.jpg";